/* import __COLOCATED_TEMPLATE__ from './current-and-future-price-component.hbs'; */
/* RESPONSIBLE TEAM: team-pricing-and-packaging */
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

export default class CurrentAndFuturePriceComponent extends Component {
  @service appService;
  @service customerService;
  @service purchaseAnalyticsService;
  @tracked showEditGraduationPlanModal = false;
  @tracked showEditGraduationAddonModal = false;
  @service notificationsService;
  @service intl;
  @service store;

  get app() {
    return this.appService.app;
  }

  get customer() {
    return this.customerService.customer;
  }

  get contract() {
    return this.args.contract;
  }

  get isSecondaryWorkspace() {
    return this.contract?.isSecondarySubscription;
  }

  get stripeMigration() {
    return this.store.peekRecord('billing/stripe-migration', this.app.id);
  }

  get hasPendingStripePricingMigration() {
    return this.stripeMigration?.isPending && !this.stripeMigration.isPlatform;
  }
}
